module.exports = __webpack_public_path__ + "static/media/incap.46f826b9.jpg";